import React from 'react'
import { NavLink } from 'react-router-dom'
import './ProjectCards.css'
import bank from '../../assets/bank.jpg'
import government from '../../assets/government.jpg'
import recipe from '../../assets/recipe.jpg'
import clothing from '../../assets/clothing.jpg'
import disease from '../../assets/disease.jpg'
import taskmanager from '../../assets/taskmanager.jpg'
import restaurantMap from '../../assets/restaurantMap.jpg'
import dataprocess from '../../assets/dataprocess.jpg'
import ttt from '../../assets/ttt.png'
import doctor from '../../assets/doctor.png'
import treasureHunter from '../../assets/Patrolling_enemy.png'
import resume from '../../assets/resume.jpg'

function ProjectCards() {
    const ProjectData = [
                {
            title: 'Heart Cardiologist Chatbot',
            techStack: 'FastAPI, NextJS, OpenAI',
            description:
                'RAG service specialized in heart/cardiology articles offered at PubMed. Cites retrieved sources, leverages chat history for back-to-back messages, and benchmarked with RAGAS metrics (faithfulness, answer relevancy, context precision/recall), achieving 93% answer relevancy.',

            image: doctor,
            view: ['https://pubmedragservice.netlify.app/'],
            source: ['https://github.com/AkashSivapalan/PubMedRAGService'],
        },
        {
            title: 'Resume ATS Analyzer',
            techStack: 'Spring Boot, AWS, OpenAI',
            description:
                'Java service that leverages OpenAI prompts to parse resumes and evaluate and provide suggestions. Deployed on AWS EC2 and stores user resumes on RDS. Manages rate limits to control token utilization.',

            image: resume,
            view: ['https://atsresumeanalysis.netlify.app/login'],
            source: ['https://github.com/AkashSivapalan/ResumeATSService'],
        },
        {
            title: 'Task Manager Web App',
            techStack: 'React, NodeJS, Express, MongoDB',
            description:
                'Full stack web application that allows users create projects with other users and manage a task board and a dashboard featuring urgent/upcoming tasks among all projects of a user.',
            image: taskmanager,
            view: ['https://task-manager-frontend-p5c4.onrender.com/'],
            source: ['https://github.com/RansikaP/project-manager'],
        },
        {
            title: 'Disease Analysis ChatBot',
            techStack: 'Python, OpenAI, Scikit Learn, FastAPI, React',
            description:
                'Web app chat bot that leverages OpenAI to process messages sent by user to understand medical symptoms they are experiences and uses an ML model to predict the disease.',
            image: doctor,
            view: ['https://meek-otter-8b544d.netlify.app/'],
            source: ['https://github.com/AkashSivapalan/DiseaseAnalysisBE'],
        },
        {
            title: 'Restaurant Recommendation App',
            techStack: 'Spring, Android Studio, MongoDB',
            description:
                'Android app that replicating tinder-like apps to create restauarant recommendations for users to view based on their preferences.',
            image: restaurantMap,
            source: [
                'https://github.com/AkashSivapalan/RestaurantRecommendationBackend',
                'https://github.com/RansikaP/ResturantReccomendationFrontend',
            ],
        },
        {
            title: '2D Platformer Game',
            techStack: 'GDScript, NodeJS, DyanmoDB',
            description:
                '2D platformer game developed in Godot Game Engine with multiple levels designs. Incorporates APIs built with AWS services(Lambda, DynamoDB, API Gateway) to facilitate user accounts functionalities and leaderboard displays.',
            image: treasureHunter,
            view: [
                'https://drive.google.com/drive/folders/1jj8wyjL-gqaoyUx1ZNy3AFTjh5wPdnYR',
            ],
            source: ['https://github.com/AkashSivapalan/AWS_Game_Challenge'],
        },
        {
            title: 'Anime Recommendation Web App',
            techStack: 'Python, NumPy, Scikit Learn, FastAPI, React',
            description:
                'Web app that uses an Anime recommendation machine learning model to give recommendations based on a list of Anime',
            image: dataprocess,
            view: ['https://animerecommendationfrontend.onrender.com/'],
            source: [
                'https://github.com/AkashSivapalan/AnimeRecommendationModel',
            ],
        },
        {
            title: 'Tic Tac Toe Game Room Web App',
            techStack: 'React, NodeJS',
            description:
                'Web app that uses web sockets to create rooms that users from difference devices can connect allow users from different devices to play tic tac toe and communicate via a chat box.',
            image: ttt,
            view: ['https://dancing-longma-9c3ae2.netlify.app/'],
            source: [
                'https://github.com/AkashSivapalan/TicTacToeBE',
                'https://github.com/AkashSivapalan/TicTacToeFE',
            ],
        },
    ]

    const handleClick = (links) => {
        links.forEach((link) => {
            window.open(link, '_blank', 'noopener,noreferrer')
        })
    }

    return (
        <div>
            <div className="project-container">
                {ProjectData.map((val, index) => {
                    return (
                        <div className="project-card">
                            <img src={val.image} />
                            <h2 className="project-title">{val.title}</h2>
                            <h3 className="project-stack">{val.techStack}</h3>
                            <div className="pro-details">
                                <p>{val.description}</p>
                                <div className="details">
                                    {val.view && (
                                        <button
                                            className="details-btn"
                                            onClick={() =>
                                                handleClick(val.view)
                                            }
                                        >
                                            View
                                        </button>
                                    )}
                                    <button
                                        className="details-btn"
                                        onClick={() => handleClick(val.source)}
                                    >
                                        Source Code
                                    </button>
                                    {/* <NavLink
                    to={val.source}
                    className="details-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Source Code
                  </NavLink> */}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ProjectCards
